export const DEVELOPER_MODE_STORAGE_KEY = "permut-developer-mode"
export const DEVELOPER_MODE_CHANGE_EVENT = "permut-developer-mode-change"

export function getDeveloperMode() {
  return localStorage.getItem(DEVELOPER_MODE_STORAGE_KEY) === "true"
}

export function storeDeveloperMode(value: boolean) {
  if (value) {
    localStorage.setItem(DEVELOPER_MODE_STORAGE_KEY, "true")
  } else {
    localStorage.removeItem(DEVELOPER_MODE_STORAGE_KEY)
  }

  window.dispatchEvent(new Event(DEVELOPER_MODE_CHANGE_EVENT))
}

export function resetDeveloperMode() {
  storeDeveloperMode(false)
}
